// frontend/src/services/marketplace/fetchMarketplaceSellerAccess.js
import { supabase } from "../../supabaseClient";

export const EMPTY_MARKETPLACE_SELLER_ACCESS = {
  isAdmin: false,
  sellerAccountId: null,
  shopId: null,
  sellerAccountStatus: null,
  shopStatus: null,
  termsAccepted: false,
  sellerTermsVersion: null,
  sellerTermsAcceptedAt: null,
  canSellOnHobbli: false,
};

export async function fetchMarketplaceSellerAccess() {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.user) {
    return EMPTY_MARKETPLACE_SELLER_ACCESS;
  }

  const { data, error } = await supabase
    .rpc("get_my_marketplace_seller_access")
    .maybeSingle();

  if (error) {
    throw error;
  }

  if (!data) {
    return EMPTY_MARKETPLACE_SELLER_ACCESS;
  }

  return {
    isAdmin: Boolean(data.is_admin),
    sellerAccountId: data.seller_account_id ?? null,
    shopId: data.shop_id ?? null,
    sellerAccountStatus: data.seller_account_status ?? null,
    shopStatus: data.shop_status ?? null,
    termsAccepted: Boolean(data.terms_accepted),
    sellerTermsVersion: data.seller_terms_version ?? null,
    sellerTermsAcceptedAt: data.seller_terms_accepted_at ?? null,
    canSellOnHobbli: Boolean(data.can_sell_on_hobbli),
  };
}

export default fetchMarketplaceSellerAccess;
